import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import { Comment } from '@/commonTypes';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import { useLayoutContext } from '@/context/LayoutContext';
import DateComponent from '@/components/general/DateComponent';
import { useTranslations } from 'next-intl';
import Ratings from './Ratings';

export default function CommentInside({
  list,
  showAllRates = false,
  showRateTitle = false,
  editFunction,
  deleteFunction,
  commentContentStyle = '',
}: {
  list?: Comment[];
  showAllRates?: boolean;
  showRateTitle?: boolean;
  editFunction?: (x: Comment) => void;
  deleteFunction?: (x: Comment) => void;
  commentContentStyle?: string;
}) {
  const { userInfo } = useLayoutContext();
  const t = useTranslations('common');

  return (
    <div className={styles.list}>
      {list?.map((item, index) => (
        <div key={index} className={`${styles.commentContent}`}>
          <UserAvatar
            name={item?.user?.name || 'بی‌نام'}
            round={true}
            size="42px"
            colorNumber={index}
            style={{ fontSize: '16px' }}
          />
          <div className={styles.comment}>
            <div className={`${styles.content} ${commentContentStyle}`}>
              <div className={styles.header}>
                <span className={styles.name}>{item?.user?.name}</span>
                <DateComponent createdAt={item?.created_at} t={t} />
              </div>

              <p className={styles.text}>{item?.content}</p>

              {item?.user?.id == userInfo?.id && (
                <div className={styles.actions}>
                  <button
                    className={styles.action}
                    onClick={() => {
                      editFunction && editFunction({ ...item });
                    }}
                  >
                    <MainIcons.editIcon width={'15px'} height={'15px'} fill="var(--text-mut)" />
                    <span>ویرایش</span>
                  </button>
                  <button
                    className={styles.action}
                    onClick={() => {
                      deleteFunction && deleteFunction({ ...item });
                    }}
                  >
                    <MainIcons.deleteIcon width={'15px'} height={'15px'} fill="var(--text-mut)" />
                    <span>حذف</span>
                  </button>
                </div>
              )}
            </div>
            <Ratings
              item={item}
              width="20px"
              showAllRates={showAllRates}
              showRateTitle={showRateTitle}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
